import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import mixpanel, { Dict } from 'mixpanel-browser';
import { environment } from '../../environments/environment';
import { AnalyticsEvents } from './analytics-events.enum';
import { AuthAccount } from '@admin-shared/models/auth-account';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private user: AuthAccount | undefined;

  constructor(private translate: TranslateService) {
    mixpanel.init(environment.mixpanelToken);
  }

  public setUser(user: AuthAccount) {
    if (!user) return;
    this.user = user;
    console.log(user);

    mixpanel.identify(user.profileId);
    mixpanel.register({
      $email: user.email,
      $first_name: user.firstName,
      $last_name: user.lastName,
    });

    mixpanel.people.set({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.contactNumber,
      name: `${user.firstName ?? ''} ${user.lastName ?? ''}`,
      $email: user.email,
      $first_name: user.firstName,
      $last_name: user.lastName,
      $phone: user.contactNumber,
      profileId: user.profileId,
      lang: this.translate.currentLang,
    });
  }

  track(event: AnalyticsEvents, props: Dict) {
    const userId = this.user?.profileId;

    mixpanel.track(event, {
      lang: this.translate.currentLang,
      userId: userId,
      ...props,
    });
  }
}
